/** @file Resolves one vertex's [bone ref, weight] input pairs to normalized [bone id, weight] influences. */
import type { Id } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';
import type { CommandContext } from '../commandContext';
import { normalizeVertexWeights } from './normalizeVertexWeights';

/** Bone refs (name or id) resolve through ctx (NOT_FOUND); VALIDATION at `path` when no weight is > 0. */
export function resolveVertexWeights(ctx: CommandContext, pairs: readonly (readonly [string, number])[], path: string): [Id, number][] {
  const resolved = pairs.map(([ref, w]): [Id, number] => [ctx.resolve('bone', ref), w]);
  return normalizeVertexWeights(resolved) ?? throwError('VALIDATION', undefined, { path, hint: 'a vertex needs at least one influence with weight > 0' });
}
